import { lazy, Suspense } from 'react';
import 'react-app-polyfill/ie9';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import { KundmarkeContextProvider } from './common/contexts/KundmarkeContext';
import {
  Footer,
  FsokNextContainer,
  Header,
  PageWrapper,
  SearchMenu,
} from './common/layout';
import MetriaThemeProvider from './MetriaThemeProvider';

const Kartstod = lazy(() => import('./kartstod/Kartstod'));
const Akt = lazy(() => import('./akt'));
const VarderingPageContainer = lazy(
  () => import('./bostadsvardering/components/VarderingPageContainer')
);
const Forteckningar = lazy(() => import('./forteckningar'));
const ForetagContainer = lazy(
  () => import('./foretag/components/ForetagContainer')
);

const Fallback = () => null;

const FsokNext = () => {
  const dev = process.env.NODE_ENV === 'development';
  return (
    <MetriaThemeProvider>
      <KundmarkeContextProvider>
        <Router>
          <FsokNextContainer rendered={dev}>
            <Header rendered={dev} />
            <SearchMenu rendered={dev} />
            <PageWrapper rendered={dev}>
              <Suspense fallback={<Fallback />}>
                <Switch>
                  <Route
                    exact={true}
                    path={'/fsok/SokPaOrganisationsnummer.seam'}
                    component={ForetagContainer}
                  />
                  <Route
                    exact={true}
                    path={'/fsok/SokPaBeteckning.seam'}
                    component={Kartstod}
                  />
                  <Route
                    exact={true}
                    path={'/fsok/SokFastighet.seam'}
                    component={Kartstod}
                  />
                  <Route
                    exact={true}
                    path={'/fsok/Bostadsvardering.seam'}
                    component={VarderingPageContainer}
                  />
                  <Route
                    exact={true}
                    path={'/fsok/Forteckningar.seam'}
                    component={Forteckningar}
                  />
                  <Route
                    exact={true}
                    path={'/fsok/Agarforteckning.seam'}
                    component={Forteckningar}
                  />
                  <Route path={'/fsok/SokPaAkt.seam'} component={Akt} />
                </Switch>
              </Suspense>
            </PageWrapper>
            <Footer rendered={dev} />
          </FsokNextContainer>
        </Router>
      </KundmarkeContextProvider>
    </MetriaThemeProvider>
  );
};

export default FsokNext;
